
import { useState } from "react"
import "../styles/AccountSettings.css"
import { Camera } from "../components/Icons"

function AccountSettings() {
  const [profileImage, setProfileImage] = useState(null)

  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const reader = new FileReader()
      reader.onload = (e) => {
        setProfileImage(e.target.result)
      }
      reader.readAsDataURL(e.target.files[0])
    }
  }

  return (
    <div className="account-container">
      <div className="account-header">
        <h1>Account Settings</h1>
      </div>

      <div className="profile-section">
        <div className="profile-image-container">
          <div className="profile-image">
            {profileImage ? (
              <img src={profileImage || "/placeholder.svg"} alt="Profile" />
            ) : (
              <div className="profile-placeholder"></div>
            )}
            <label htmlFor="profile-upload" className="camera-icon">
              <Camera />
            </label>
            <input
              type="file"
              id="profile-upload"
              accept="image/*"
              onChange={handleImageChange}
              style={{ display: "none" }}
            />
          </div>

          <div className="profile-info">
            <h2>Marry Doe</h2>
            <p>Marry@Gmail.Com</p>
          </div>
        </div>

        <div className="profile-bio">
          <p>
            Lorem Ipsum Dolor Sit Amet, Consetetur Sadipscing Elitr, Sed Diam Nonumy Eirmod Tempor Invidunt Ut Labore Et
            Dolore Magna Aliquyam Erat, Sed Diam
          </p>
        </div>
      </div>

      <div className="divider"></div>
    </div>
  )
}

export default AccountSettings

